export default __webpack_public_path__ + "93a82df0356ed32d3d423f19505d6074.svg";